import { render, staticRenderFns } from "./rejectTrash.vue?vue&type=template&id=378807e7"
import script from "./rejectTrash.vue?vue&type=script&lang=js"
export * from "./rejectTrash.vue?vue&type=script&lang=js"
import style0 from "./rejectTrash.vue?vue&type=style&index=0&id=378807e7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports